// extracted by mini-css-extract-plugin
module.exports = {"container":"virtualAssistantSummaryPage_container__1W76R","summaryContainer":"virtualAssistantSummaryPage_summaryContainer__1SnpE","buttonContainer":"virtualAssistantSummaryPage_buttonContainer__3sspq","button":"virtualAssistantSummaryPage_button__3T2Qq","title":"virtualAssistantSummaryPage_title__1oMSU"};
    if(module.hot) {
      // 1744882526805
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  